import * as React from 'react';
export const ListDetailContext = React.createContext({
    sidebarWidth: 0.3,
});
export function normalizeSidebarWidth(width) {
    if (width === 'content')
        return 'content';
    if (Number.isNaN(width))
        return 0.3;
    return Math.min(1, Math.max(0, width));
}
//# sourceMappingURL=list-detail-context.js.map